// extracted by css-extract-rspack-plugin
export default {"safe-area-top":"simulated-safe-areas_safe-area-top__-Iqii","safe-area-bottom":"simulated-safe-areas_safe-area-bottom__uFpOL"};